import PropTypes from 'prop-types'

import {atomPanelElevation} from '@s-ui/react-atom-panel'
import PanelBasic from '@adv-mt/mt-panel-basic'

import {Button} from './components/BannerBasicButton.js'
import {Description} from './components/BannerBasicDescription.js'
import {Title} from './components/BannerBasicTitle.js'
import {BASE_CLASS} from './config.js'

const BANNER_BASIC_ELEVATION = atomPanelElevation

function BannerBasic({children, elevation = BANNER_BASIC_ELEVATION.S, ...props}) {
  return (
    <div className={BASE_CLASS}>
      <PanelBasic elevation={elevation} {...props}>
        {children}
      </PanelBasic>
    </div>
  )
}

BannerBasic.propTypes = {
  children: PropTypes.node.isRequired,
  elevation: PropTypes.oneOf(Object.values(BANNER_BASIC_ELEVATION))
}

BannerBasic.Title = Title
BannerBasic.Description = Description
BannerBasic.Button = Button

export default BannerBasic
export {BANNER_BASIC_ELEVATION as bannerBasicElevation}
